import React, { ChangeEvent, useEffect, useState, useCallback } from "react";
import QRCode from "react-qr-code";

import { Button, Form, StandaloneFormPage } from "tabler-react";
import { useAuth } from "../../hooks/AuthContext";
import { useHistory } from "react-router-dom";
import { Alerta } from "../../utils/Alerta";
import logo from "../../assets/img/logo.svg";
import api from "../../services/api";

const ConfigureTwoFactors = () => {
  const history = useHistory();
  const apiSender = api();
  const { email, passwordTmp, store } = useAuth();

  const [qrcodeLink, setQRCodeLink] = useState("");
  const [code, setCode] = useState<string>()

  const handleKeyConfirmCodeTotp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !!code) {
      confirmCodeTotp();
    }
  };

  const generateQRCode = useCallback(async () => {
    if (!email || !passwordTmp) return;

    const data = {
      email: email,
      password: passwordTmp,
    };

    try {
      const qrCode = await apiSender.post("cognito/generateqrcode", data);
      setQRCodeLink(qrCode.data.URL);
    } catch (err) {
      Alerta("Erro ao gerar QRCode");
    }
  }, [email, passwordTmp]);

  useEffect(() => {
    if (!email || !passwordTmp) {
      history.push('/');
      return;
    }

    generateQRCode();
  }, [email, passwordTmp, history, generateQRCode]);

  async function confirmCodeTotp() {
    if (!email || !passwordTmp) {
      history.push('/');
      Alerta("Não foi possível ativar a autenticação de dois fatores!");
      return;
    }

    const data = {
      email: email,
      password: passwordTmp,
      codeTotp: code,
    };

    try {
      await apiSender.post("cognito/confirmecodetotp", data);

      if (!!store) {
        store.needCreateTwoFactorAuth = false;
        store.twoFactorAuthentication = false;
      }

      history.push('/');
    } catch (err) {
      Alerta("Não foi possível ativar a autenticação de dois fatores!");
    }
  }

  return (
    <StandaloneFormPage
      imageURL={logo}
      children={
        <Form>
          <p>Escaneie o QR acima com um app autenticador no seu celular. Baixe o app pela Google Play (Android) ou App Store (iOS).</p>

          <QRCode size={360} value={qrcodeLink} viewBox={`0 0 256 256`}/>

          <Form.Group
            label="Digite no campo abaixo o código que aparece agora no seu app autenticador."
            className="form-reset"
            mt={6}
          >
          <Form.Input placeholder="Code 2FA"
            onChange={(event: ChangeEvent<HTMLInputElement>) => setCode(event.target.value)}
            name="confirmPassword"
            onKeyDown={handleKeyConfirmCodeTotp}
            height={2}
          /></Form.Group>

          <Button
            size="sm"
            href="#"
            RootComponent="a"
            color="primary"
            style={{width:"100%"}}
            onClick={confirmCodeTotp}
            disabled={!code}
          >
            Verificar Codígo
          </Button>
        </Form>
      }
    />
  );
};

export default ConfigureTwoFactors;
